import { render } from "./popoverComponent.vue?vue&type=template&id=2dc6a3fc&ts=true"
import script from "./popoverComponent?vue&type=script&lang=ts"
export * from "./popoverComponent?vue&type=script&lang=ts"

import "./_assets/_popover.scss?vue&type=style&index=0&lang=scss"

import exportComponent from "/home/runner/work/atlantis/atlantis/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__